import React from "react";

const renderExpSkeleton = (
  <div className="w-full rounded-lg border border-gray-200 bg-white pb-[11px] pl-3 pr-3 pt-[11px] shadow-md">
    <div className="flex gap-2">
      <div className="shimmer h-12 w-12 rounded bg-gray-200"></div>
      <div className="flex w-full flex-col justify-center">
        <div className="shimmer mb-1 h-6 rounded bg-gray-200"></div>
        <div className="shimmer h-6 w-3/4 rounded bg-gray-200"></div>
      </div>
    </div>

    <div className="mt-3 space-y-1">
      <div className="flex items-center">
        <div className="shimmer h-4 w-4 rounded-full bg-gray-200"></div>
        <div className="shimmer ml-2 h-4 w-36 rounded bg-gray-200"></div>
      </div>
      <div className="flex items-center">
        <div className="shimmer h-4 w-4 rounded-full bg-gray-200"></div>
        <div className="shimmer ml-2 h-4 w-52 rounded bg-gray-200"></div>
      </div>
      <div className="flex items-center">
        <div className="shimmer h-4 w-4 rounded-full bg-gray-200"></div>
        <div className="shimmer ml-2 h-4 w-32 rounded bg-gray-200"></div>
      </div>
      <div className="flex items-center">
        <div className="shimmer h-4 w-4 rounded-full bg-gray-200"></div>
        <div className="shimmer ml-2 h-4 w-40 rounded bg-gray-200"></div>
      </div>
    </div>

    <div className="mt-3 flex items-center justify-between">
      <div className="flex items-center">
        <div className="mr-2 flex items-center space-x-1">
          <div className="shimmer h-1.5 w-1.5 rounded-full bg-gray-300"></div>
          <div className="shimmer h-1.5 w-1.5 rounded-full bg-gray-300"></div>
          <div className="shimmer h-1.5 w-1.5 rounded-full bg-gray-300"></div>
        </div>
        <div className="shimmer h-5 w-28 rounded bg-gray-200"></div>
      </div>
    </div>
  </div>
);

const Skeleton = () => {
  return <div>{renderExpSkeleton}</div>;
};

export default Skeleton;
